<!--
 * @Author: ZS
 * @Date: 2020-06-23 08:41:16
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-15 17:53:01
 * @Description: file content
-->
<template>
  <div>
    <h3 class="myTit clearfix">
      <span>我的收藏</span>
    </h3>
    <div class="collectionBox">
      <ul class="ywtbListsContent clearfix noselect">
        <li class="searchShow" v-for="(item,index) in contentList" :key="index">
          <img :src="item.portal_pc_handling_guideline_img">
          <div
              class="collection_wrap"
              v-if="$store.state.isLogin"
              :class="{
                active: true
              }"
              @click="collection(item)"
            >
              <i
                class="iconfont icon-sc"
                :class="{active: true}"
              ></i><span>&nbsp;取消收藏</span>
            </div>
          <h3 :title="item.portal_pc_handling_guideline_name">{{item.portal_pc_handling_guideline_name}}</h3>
          <!-- 部门名称 -->
            <div class="dept_name_wrap">{{item.dept_name}}</div>
            <!-- 评分 -->
            <div class="score_wrap">
              <el-rate
                :value="item.satisfaction || 0"
                disabled
                :show-score="false"
                text-color="#ff9900"
              >
              </el-rate>
            </div>
          <a href="javascript:;" class="btn btn-primary znBtn"
          v-if="String(item.portal_pc_handling_guideline) === '1'"
            @click="viewDetail(item.portal_pc_handling_guideline_id,item.portal_pc_handling_guideline_code)">办事指南</a>
          <a :href="item.portal_pc_handling_guideline_url"
          v-if="[null, undefined, ''].indexOf(item.portal_pc_handling_guideline_url) === -1 && item.ljbl === 1"
          @click="globalAddVisit(item.portal_pc_handling_guideline_code)"
          class="btn btn-primary blBtn" target="_blank">立即办理</a>
          <!-- <i class="iconfont icon-sc active" @click="collection(item)"></i> -->
        </li>
      </ul>
      <div class="noData" v-if="contentList.length == 0">
        <img src="../../../assets/images/null.png" alt="">
        <p>暂无收藏</p>
      </div>
    </div>
  </div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        contentList: [],
      }
    },
    mounted() {
      this.getCollection();
    },
    methods: {
      viewDetail(id, code) {
        this.$router.push({
          path: '/guide',
          query: {
            code
          }
        })
      },
      getCollection() {
        let sendData = qs.stringify({
          userCode: this.$store.state.userId
        })
        this.ywtbRequest('/portal-ywtb/web/collection/getCollectionByUserCode', sendData).then(res => {
          var data = res.dataList
          for (let i = 0; i < data.length; i++) {
              data[i].portal_pc_handling_guideline_img = `/portal-ywtb/${data[i].portal_pc_handling_guideline_img}`;
            // data[i].portal_pc_handling_guideline_img =
              // '/portal-ywtb/public/getImg?path=' + encodeURI(data[i].portal_pc_handling_guideline_img)
          }
          this.contentList = data
        })
      },
      collection(item) {
        let sendData = qs.stringify({
          collectionGuidelineCode: item.portal_pc_handling_guideline_code
        });
        // console.log(item);
        //如果未收藏就发送收藏请求,否则发送取消收藏请求
        let url = '/portal-ywtb/web/collection/deleteCollection';
        this.ywtbRequest(url, sendData).then(res => {
          if (res.status == 200) {
            this.$message({
              message: '操作成功',
              type: 'success'
            });
            this.getCollection()
          }
        })
      }
    }
  }

</script>

<style lang="scss" scoped>
  .myTit {
    /* line-height: 42px; */
    padding: 30px 0 15px 0;
    font-size: 16px;
    margin-bottom: 10px;
  }

  .myTit>span {
    float: left;
    color: #091B28;
    font-size: 22px;
    font-family: PingFang SC;
  }

  .ywtbListsContent li {
    float: left;
    width: 294px;
    // height: 110px;
    height: 132px;
    border: 1px solid #eaeaea;
    border-radius: 4px;
    position: relative;
    padding: 17px 18px 0 90px;
    margin: 10px 5px;
    box-shadow: 0px 3px 12px 0px rgba(0, 0, 0, 0.05);
  }

  .ywtbListsContent li .iconfont {
    // position: absolute;
    // right: 10px;
    // top: 6px;
    color: #c5c5c5;
    // display: none;
    cursor: pointer;
  }

  .ywtbListsContent li:hover .iconfont {
    // display: block;
  }

  .ywtbListsContent li .iconfont.active {
    color: #fa1818;
  }

  .ywtbListsContent li:hover {
    border: 1px solid rgba(233, 26, 34, 1);
    box-shadow: 0px 0.25rem 1.25rem rgba(233, 26, 34, 0.2);
  }

  .ywtbListsContent li>img {
    width: 60px;
    height: 60px;
    position: absolute;
    top: 20px;
    left: 18px;
  }

  .ywtbListsContent li>h3 {
    font-size: 16px;
    font-weight: 700;
    color: #4B4F58;
    // width: 216px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .ywtbListsContent li>p {
    margin-top: 10px;
    // width: 216px;
    height: 40px;
    text-overflow: -o-ellipsis-lastline;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #95A1B7;
  }

  .ywtbListsContent li>a {
    width: 86px;
    padding: 4px 12px;
    border: 1px solid rgba(71, 114, 189, 1);
    border-radius: 4px;
    margin-top: 4px;
    margin-left: 3px;
  }

  .ywtbListsContent li .znBtn {
    color: #4772BD;
    background-color: #fff;
  }

  .ywtbListsContent li .blBtn {
    color: #fff;
    background-color: #4772BD;
  }

  .classify-list li.active a {
    border: 1px solid;
    color: #fff;
  }

  .noData {
    text-align: center;
  }

  .noData p {
    font-size: 16px;
    color: #666;
  }

.collection_wrap {
  position: absolute;
  left: 0;
  bottom: 14px;
  // display: none;
  left: 20px;
  font-size: 12px;
  cursor: pointer;
  .iconfont {
    font-size: 14px;
    display: inline-block;
    transform: translateY(1px);
  }
  span {
    color: #aaa;
  }
  &.active {
    .iconfont, span {
      color: rgb(247, 186, 42) !important;
      // color: #fa1818;
    }
  }
}
.dept_name_wrap {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 14px;
}
.score_wrap /deep/ {
  .el-rate {
    i {
      font-size: 14px;
    }
  }
}
.ywtbListsContent li:hover .collection_wrap {
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/user/MyCollection.vue